import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVideo360 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	width: 24,
	height: 24,
	strokeWidth: 2,
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M14 6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 5h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M17 7v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0z" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 16c0 1.657 4.03 3 9 3s9 -1.343 9 -3" })
	]
});
const ForwardRef = forwardRef(SvgVideo360);
export default ForwardRef;
